import { Navigate } from 'react-router-dom';
import { Ellie } from '../components/Ellie';
import { useFeatureFlag } from '../services/featureFlag.service';
import { FeatureFlag } from '../services/featureFlag.service';
import FeatureFlagService from '../services/featureFlag.service';
import { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import elliePng from '../assets/images/pliable/ellie.png';
import PageTitle from '../components/PageTitle';

export default function ElliePage({
  embedThreadId,
  showHistory: embedShowHistory = false,
  centerInputOnNewChat: embedCenterInput,
  placeholder: embedPlaceholder,
  welcomeMessage: embedWelcomeMessage,
}: {
  embedThreadId?: string;
  showHistory?: boolean;
  centerInputOnNewChat?: boolean;
  placeholder?: string;
  welcomeMessage?: string;
} = {}) {
  const isAiAssistantEnabled = useFeatureFlag('ai-assistant', false);
  const useCasesEnabled = useFeatureFlag(FeatureFlag.ALLOW_USECASE_MANAGEMENT, false);
  const [flagsReady, setFlagsReady] = useState(() => FeatureFlagService.getInstance().isReady);
  const isEmbedded =
    typeof window !== 'undefined' && window.location.pathname === '/embed';

  useEffect(() => {
    if (flagsReady) return;
    FeatureFlagService.getInstance().waitForInitialization().then(() => setFlagsReady(true));
  }, [flagsReady]);

  if (!flagsReady) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isAiAssistantEnabled) {
    return (
      <div className="flex items-center justify-center h-screen w-full">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  const agentType = useCasesEnabled ? 'ellie' : 'analyst';

  return (
    <div className="h-screen w-full flex flex-col">
      {/* Embedded chat is white-labeled: no Ellie identity header, no advanced controls */}
      {!isEmbedded && (
        <div className="flex-shrink-0 p-4 border-b border-border flex items-center gap-3">
          <img src={elliePng} alt="Ellie" className="h-10 w-10 rounded-full object-cover" />
          <div>
            <PageTitle title="Hi, I'm Ellie" />
            <p className="text-sm text-muted-foreground">Your AI chief of staff — ask me about your business and get recommendations on how to change your strategy.</p>
          </div>
        </div>
      )}
      <div className="flex-1 min-h-0 overflow-hidden">
        {isEmbedded ? (
          // With history, the chat + sidebar use the full width; without it,
          // the lone conversation stays centered at 3/4 width.
          <div className={embedShowHistory ? 'h-full w-full' : 'h-full w-3/4 mx-auto'}>
            <Ellie showHistory={embedShowHistory} agentType={agentType} conversationId={embedThreadId} embedded centerInputOnNewChat={embedCenterInput} placeholder={embedPlaceholder} welcomeMessage={embedWelcomeMessage} />
          </div>
        ) : (
          <Ellie showHistory={true} agentType={agentType} />
        )}
      </div>
    </div>
  );
}
